<div class="cookie-banner" *ngIf="isVisible" role="dialog" aria-live="polite" aria-label="Cookie notice">
  <div class="cookie-header">
    <i class="fas fa-cookie-bite"></i>
    <span class="cookie-title">{{ 'COOKIES.TITLE' | translate }}</span>
  </div>
  <p class="cookie-message">{{ 'COOKIES.MESSAGE' | translate }}</p>
  <button type="button" class="cookie-accept" (click)="accept()">
    {{ 'COOKIES.ACCEPT' | translate }}
  </button>
</div>
